import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLocaleRoute } from './useLocaleRoute.js';

/**
 * App-wide navigation helpers (replaces setPage state).
 *
 * @returns {object}
 */
export function useAppNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { locale, localizedPath } = useLocaleRoute();

  /**
   * @param {string} targetPage
   */
  const toPage = useCallback((targetPage) => {
    navigate(localizedPath(targetPage));
  }, [navigate, localizedPath]);

  /**
   * @param {string} sectionId
   */
  const toHomeSection = useCallback((sectionId) => {
    navigate(localizedPath('home', sectionId));

    if (typeof window === 'undefined') {
      return;
    }

    window.setTimeout(() => {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }, [navigate, localizedPath]);

  return { toPage, toHomeSection, navigate, locale };
}
